import BlockContent from "@sanity/block-content-to-react";
import styles from "gui/text/text.module.css";
import { Figure } from "gui/figure/figure";
import { Grid } from "gui/grid/grid";
import { SanityBlock } from "lib/sanity/types";
import { SanityFigure } from "lib/sanity/types";
import { SanityRich } from "lib/sanity/types";
import { SanityTweet } from "lib/sanity/types";
import { Tweet } from "gui/tweet/tweet";

export const Text: React.FC<{
  item: SanityRich;
}> = (props) => {
  return (
    <Grid revealOnLoad gaps>
      <TextBlocks className={styles.html} blocks={props.item.text} />
    </Grid>
  );
};

export const TextBlocks: React.FC<{
  blocks: SanityBlock[];
  className?: string;
}> = (props) => {
  return (
    <BlockContent
      blocks={props.blocks}
      className={props.className}
      serializers={serializers}
      renderContainerOnSingleChild
    />
  );
};

const serializers = {
  types: {
    figure: (props: { node: SanityFigure }) => {
      return <Figure item={props.node} width={780} format="jpg" />;
    },
    tweet: (props: { node: SanityTweet }) => {
      return <Tweet item={props.node} />;
    },
  },
};
